import TrendingPage from './TrendingPage'

export default TrendingPage
